<template>
  <div>
    <b-modal :title="'اضافه کردن موضوع'" id="categoryModal" v-model="showModal" no-close-on-esc header-close-variant="dark" hide-footer centered>
      <BaseText
        required
        :showError="titleError"
        :value="selectedCategory.title"
        @input="selectedCategory.title = $event"
        title="عنوان "
        placeholder="عنوان"
        labelClass="labelClass"
      />

      <div class="d-flex justify-content-end align-items-center mt-3 gap-2">
        <b-button variant="secondary" @click="$bvModal.hide('categoryModal'), (selectedCategory = {})">انصراف</b-button>

        <!-- <b-button variant="primary ms-2 px-5" @click="addCategory">ثبت</b-button> -->
        <Button @click.native="addCategory" :loading="loading" text="ثبت" btnClass="upload-btn btn-border" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import moocCategoryProvider from '../../../services/mooc/category'
import Button from '../../common/Button.vue'

export default {
  name: 'AddCategory',
  components: { BaseText, Button },
  props: {
    category: {
      type: Object,
      default: () => {},
    },
  },
  data: () => {
    return {
      selectedCategory: {
        id: undefined,
        title: '',
      },
      loading: false,
      showModal: false,
      titleError: false,
    }
  },
  watch: {
    category(val) {
      if (val) this.selectedCategory = val
    },
    showModal(val) {
      if (!val) {
        this.selectedCategory = {}
        this.titleError = false
      }
    },
  },
  methods: {
    async addCategory() {
      if (!this.selectedCategory.title) return (this.titleError = true)
      let result
      const payload = { ...this.selectedCategory }
      this.loading = true
      try {
        if (this.$route.params.slug === 'universitycategorycourse') {
          if (this.selectedCategory.id) result = await moocCategoryProvider.updateCategoryCourse(payload)
          else result = await moocCategoryProvider.AddCategoryCourse(payload)
        } else if (this.$route.params.slug === 'universitycategorypackage') {
          if (this.selectedCategory.id) result = await moocCategoryProvider.updateCategoryPackage(payload)
          else result = await moocCategoryProvider.AddCategoryPackage(payload)
        }
        if (result.status >= 200 || result.status <= 204) {
          this.$emit('update')
          this.showModal = false
          this.selectedCategory = {}
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.labelClass {
  min-width: 10px !important;
}

.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}
</style>
